import { i18n } from '@/plugins/i18n';
import { POSITIONS_SIDE } from '@core/option';

const { t } = i18n.global;

const OPTION_REQUEST_STATE = {
  1: t('option.waitingForApply'),
  2: t('misc.notApplied'),
  3: t('option.waitingForApply'),
  4: t('option.waitingForApply'),
  5: t('misc.applied'),
  6: t('misc.notApplied'),
} as const;

const POSITION_SIDE_LABELS = {
  [POSITIONS_SIDE.buy]: t('common.buy'),
  [POSITIONS_SIDE.sell]: t('common.sell'),
} as const;

const CASH_AGREE_TO_SETTLE_BY_PROPORTION_LABELS = {
  true: t('option.agreeToSettleByProportion'),
  false: t('-'),
} as const;

const PHYSICAL_AGREE_TO_SETTLE_BY_PROPORTION_LABELS = {
  true: t('option.agreeToSettlementAtLossOrIndifferent'),
  false: t('-'),
} as const;

const REQUEST_TYPE_LABELS = {
  true: t('option.requestType.maximum'),
  false: t('option.requestType.elective'),
} as const;

const SETTLEMENT_TYPE = {
  0: t('option.notSettlemented'),
  1: t('option.settlementRequest.cash'),
  2: t('option.settlementRequest.physical'),
  3: `${t('option.settlementRequest.cash')} - ${t(
    'option.settlementRequest.physical'
  )}`,
} as const;

const POSITIONS_HISTORY_STATUS = {
  settlemented: t('option.settlemented'),
  notSettlemented: t('option.notSettlemented'),
} as const;

const SETTLEMENT_STATUS = {
  applied: t('misc.applied'),
  notApplied: t('misc.notApplied'),
  waitingForApply: t('option.waitingForApply'),
} as const;

const FREEZE_UNFREEZE_TABS = {
  freeze: {
    label: t('option.freeze'),
    value: 0,
  },
  unfreeze: {
    label: t('option.unFreeze'),
    value: 1,
  },
};

const POSITION_DETAIL_TABS = {
  detail: {
    label: t('option.detail'),
    value: 0,
  },
  performance: {
    label: t('option.performance'),
    value: 1,
  },
  settlement: {
    label: t('option.settlement'),
    value: 2,
  },
};

const CHAIN_STATUS = {
  CLOSED: {
    label: t('misc.closed'),
    labelClass: 'text-critical-primary',
    value: 0,
  },
  OPEN: {
    label: t('misc.open'),
    labelClass: 'text-brand-primary',
    value: 1,
  },
  AT_RISK: {
    label: t('misc.atRisk'),
    labelClass: 'text-warning-primary',
    value: 2,
  },
};

const OPTIONS_STATUS = {
  positions: t('option.openPosition'),
  strategies: t('option.openStrategies'),
  embeddedPutOptionSymbols: t('modules.portfolio.embeddedPutOption.title'),
} as const;

const OPTION_POSITION_ORDER_TYPES = {
  positions: {
    value: 'positions',
    label: OPTIONS_STATUS.positions,
  },
  strategies: {
    value: 'strategies',
    label: OPTIONS_STATUS.strategies,
  },
} as const;

const ORDER_FILTER_OPTIONS = Object.values(OPTION_POSITION_ORDER_TYPES);

export {
  OPTION_REQUEST_STATE,
  POSITION_SIDE_LABELS,
  POSITIONS_HISTORY_STATUS,
  SETTLEMENT_STATUS,
  CASH_AGREE_TO_SETTLE_BY_PROPORTION_LABELS,
  PHYSICAL_AGREE_TO_SETTLE_BY_PROPORTION_LABELS,
  REQUEST_TYPE_LABELS,
  SETTLEMENT_TYPE,
  FREEZE_UNFREEZE_TABS,
  POSITION_DETAIL_TABS,
  OPTION_POSITION_ORDER_TYPES,
  ORDER_FILTER_OPTIONS,
  CHAIN_STATUS,
};
